import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import Incoterms from '../../models/Incoterms'

export interface IncotermsListState extends PaginatedApiState {
  incoterms?: Incoterms[]
}

const IncotermsList = (state: IncotermsListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<IncotermsListState>('INCOTERMS_LIST')(state, action)
  }
}

export default IncotermsList
